import { render, staticRenderFns } from "./base-node.vue?vue&type=template&id=73a0982a&"
import script from "./base-node.vue?vue&type=script&lang=js&"
export * from "./base-node.vue?vue&type=script&lang=js&"
import style0 from "./base-node.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports